/**
 * Bracket Simulator API Service
 *
 * All API calls for the NCAA Tournament Bracket Simulator.
 */

import api from './api';

const BASE = '/bracket';

// ==================== TOURNAMENT FIELD ====================

export const getTournamentField = async (season) => {
  const response = await api.get(`${BASE}/tournament/${season}/teams`);
  return response.data;
};

export const getSeedHistory = async (season) => {
  const response = await api.get(`${BASE}/tournament/${season}/seed-history`);
  return response.data;
};

// ==================== BRACKET CRUD ====================

export const createBracket = async ({ bracket_name, strategy, season }) => {
  const response = await api.post(`${BASE}/brackets`, {
    bracket_name,
    strategy,
    season,
  });
  return response.data;
};

export const listBrackets = async (season) => {
  const response = await api.get(`${BASE}/brackets`, { params: { season } });
  return response.data;
};

export const getBracket = async (bracketId) => {
  const response = await api.get(`${BASE}/brackets/${bracketId}`);
  return response.data;
};

export const deleteBracket = async (bracketId) => {
  const response = await api.delete(`${BASE}/brackets/${bracketId}`);
  return response.data;
};

export const cloneBracket = async (bracketId) => {
  const response = await api.post(`${BASE}/brackets/${bracketId}/clone`);
  return response.data;
};

// ==================== PICKS ====================

export const makePick = async (bracketId, pick) => {
  const response = await api.put(`${BASE}/brackets/${bracketId}/picks`, pick);
  return response.data;
};

// ==================== AUTO-FILL ====================

export const autoFillBracket = async (bracketId, strategy, customParams = null) => {
  const body = { strategy };
  if (customParams) {
    if (customParams.upset_targets) body.upset_targets = customParams.upset_targets;
    if (customParams.weights) body.weights = customParams.weights;
  }
  const response = await api.post(`${BASE}/brackets/${bracketId}/auto-fill`, body);
  return response.data;
};

// ==================== SHARING ====================

export const shareBracket = async (bracketId) => {
  const response = await api.post(`${BASE}/brackets/${bracketId}/share`);
  return response.data;
};

export const getSharedBracket = async (shareCode) => {
  const response = await api.get(`${BASE}/shared/${shareCode}`);
  return response.data;
};

// ==================== PREDICTIONS ====================

export const getBracketPredictions = async (bracketId, season = 2026) => {
  const response = await api.get(`${BASE}/brackets/${bracketId}/predictions`, {
    params: { season },
  });
  return response.data;
};

// ==================== MATCHUP ANALYSIS ====================

export const analyzeMatchup = async (team1EntryId, team2EntryId, roundNumber) => {
  const response = await api.get(`${BASE}/matchup-analysis`, {
    params: {
      team1_entry_id: team1EntryId,
      team2_entry_id: team2EntryId,
      round_number: roundNumber,
    },
  });
  return response.data;
};

// ==================== MASCOT BATTLE ====================

export const getMascotBattle = async (team1EntryId, team2EntryId) => {
  const response = await api.get(`${BASE}/mascot-battle`, {
    params: {
      team1_entry_id: team1EntryId,
      team2_entry_id: team2EntryId,
    },
  });
  return response.data;
};

// ==================== SIMULATION ====================

export const getSimulation = async (season, strategy) => {
  const response = await api.get(`${BASE}/simulation/${season}/${strategy}`);
  return response.data;
};

export const runSimulation = async (season, { strategy, num_simulations = 10000 }) => {
  const response = await api.post(`${BASE}/simulation/${season}/run`, {
    strategy,
    num_simulations,
  });
  return response.data;
};
